/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const opts = {
    composed: true,
    bubbles: false,
    cancelable: true,
};
export class PendingEvent extends Event {
    data;
    static eventName = "pending";
    constructor(data) {
        super(PendingEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class InputEvent extends Event {
    running;
    data;
    static eventName = "input";
    constructor(running, data) {
        super(InputEvent.eventName, { ...opts });
        this.running = running;
        this.data = data;
    }
}
export class OutputEvent extends Event {
    data;
    static eventName = "output";
    running = true;
    constructor(data) {
        super(OutputEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class SecretEvent extends Event {
    running;
    data;
    static eventName = "secret";
    constructor(running, data) {
        super(SecretEvent.eventName, { ...opts });
        this.running = running;
        this.data = data;
    }
}
export class RunnerErrorEvent extends Event {
    data;
    static eventName = "error";
    running = false;
    constructor(data) {
        super(RunnerErrorEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class EndEvent extends Event {
    data;
    static eventName = "end";
    running = false;
    constructor(data) {
        super(EndEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class SkipEvent extends Event {
    data;
    static eventName = "skip";
    running = true;
    constructor(data) {
        super(SkipEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class GraphStartEvent extends Event {
    data;
    static eventName = "graphstart";
    running = true;
    constructor(data) {
        super(GraphStartEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class GraphEndEvent extends Event {
    data;
    static eventName = "graphend";
    running = true;
    constructor(data) {
        super(GraphEndEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class NodeStartEvent extends Event {
    data;
    result;
    static eventName = "nodestart";
    running = true;
    constructor(data, result) {
        super(NodeStartEvent.eventName, { ...opts });
        this.data = data;
        this.result = result;
    }
}
export class NodeEndEvent extends Event {
    data;
    static eventName = "nodeend";
    running = true;
    constructor(data) {
        super(NodeEndEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class PauseEvent extends Event {
    running;
    data;
    static eventName = "pause";
    constructor(running, data) {
        super(PauseEvent.eventName, { ...opts });
        this.running = running;
        this.data = data;
    }
}
export class ResumeEvent extends Event {
    data;
    static eventName = "resume";
    running = true;
    constructor(data) {
        super(ResumeEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class StartEvent extends Event {
    data;
    static eventName = "start";
    running = true;
    constructor(data) {
        super(StartEvent.eventName, { ...opts });
        this.data = data;
    }
}
export class StopEvent extends Event {
    running;
    data;
    static eventName = "stop";
    constructor(running, data) {
        super(StopEvent.eventName, { ...opts });
        this.running = running;
        this.data = data;
    }
}
export class NextEvent extends Event {
    data;
    static eventName = "next";
    constructor(data) {
        super(NextEvent.eventName, { ...opts });
        this.data = data;
    }
}
//# sourceMappingURL=events.js.map